export * from '@yandex-int/hr-components/ErrorState';
